/**
 * 詳情頁三個詢問入口各自帶進表單的預填值（AV P6）。
 *
 * 三個入口共用同一個 `InquiryForm`，而表單的 `seedFromProps()` 每次開啟都會跑一遍、
 * 且 `if (props.seedBroadcast) broadcast.value = true` 只設不清——表單自己的 `reset()`
 * 清得掉本地的 `broadcast`，清不掉 props。所以**每個入口都必須完整地宣告自己的預填值**，
 * 不能只改需要改的欄位、讓上一次的殘留下來。
 *
 * 真正會咬人的是「一般入口」：它沒有日期也沒有廣播意圖，如果沿用上一次 ✕ 那天按下
 * 「一起問類似場地」留下的 `broadcast: true`，租客按「詢問這個場地」會得到一個廣播
 * 表單，一送就扇出到他沒選過的場地——使用者沒要求的對外動作。
 */

export interface InquirySeed {
    date: string
    time: string
    /** 只有「整天沒了 → 一起問類似場地」那條路才為真。 */
    broadcast: boolean
}

/** 一般入口（「詢問這個場地」）：不帶日期、不帶時段、**永遠不帶廣播**。 */
export function plainSeed(): InquirySeed {
    return {date: '', time: '', broadcast: false}
}

/** 日曆「用這個時段詢問」：帶日期與時段，問的仍是這一個場地。 */
export function slotSeed(date: string, time: string): InquirySeed {
    return {date, time, broadcast: false}
}

/**
 * 日曆「一起問類似場地」：那天問這個場地必定被後端的閘擋下，唯一還說得通的出口
 * 是問類似場地。只帶日期不帶時段——整天都沒了，沒有時段可填。
 */
export function broadcastSeed(date: string): InquirySeed {
    return {date, time: '', broadcast: true}
}
